module.exports = __webpack_public_path__ + "img/white_background.61681e09.jpg";